import {fragments} from "@Common/react/fragments";
import {OnMounted} from "@Common/react/on-mounted";
import {Watch}     from "@Common/react/watch";
import {equalDeep} from "@Common/utils/objects";

export const Repeating = ({action, watchValue}) => {
    const action1 = () => {
        action(watchValue);
    };
    return fragments(
        OnMounted({
            action: action1,
        }),
        Watch({
            value: watchValue,
            compare: equalDeep,
            onChanged: action1,
        }),
    );
};
